import { render, staticRenderFns } from "./InterestingFacts.vue?vue&type=template&id=41e64ca6&scoped=true"
import script from "./InterestingFacts.vue?vue&type=script&lang=js"
export * from "./InterestingFacts.vue?vue&type=script&lang=js"
import style0 from "./InterestingFacts.vue?vue&type=style&index=0&id=41e64ca6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e64ca6",
  null
  
)

export default component.exports